// 仅移除接口路径前缀中的 /api，保留实际业务路径不变。
export const removeApiPrefix = (path) => {
  if (typeof path !== 'string') {
    return path;
  }

  if (path === '/api') {
    return '';
  }

  if (path.startsWith('/api/')) {
    return path.slice(4);
  }

  return path;
};
